import { apiSchemas } from '@verifime/api-definition';
import { stringUtils, TObject } from '@verifime/utils';
import { z } from 'zod';

export type TMedicareCardOwners = {
  id: string;
  name: any;
}[];

export type TOcrData = z.infer<typeof apiSchemas.ScanDocumentApiResponse> &
  Partial<{
    otherIdentityDocument: z.infer<typeof apiSchemas.OtherIdentityDocument>;
  }>;

export const SUPPORT_OCR_DOCUMENT_TYPES = [
  'DriverLicence',
  'MedicareCard',
  'Passport',
  'OtherIdentityDocument',
] as const;
export type TSupportedOcrDocumentType = (typeof SUPPORT_OCR_DOCUMENT_TYPES)[number];

export const documentLabelMapping: { [documentType in TSupportedOcrDocumentType]: string } = {
  DriverLicence: "driver's licence",
  MedicareCard: 'medicare card',
  Passport: 'passport',
  OtherIdentityDocument: 'other identity document',
};

export function objectMedicareCardOwnersToArray(objOwners: TObject): TMedicareCardOwners {
  if (Object.keys(objOwners || {}).length < 1) {
    return [];
  }
  return Object.entries(objOwners).map(([id, name]) => ({ id, name }));
}

export function buildOcrData(
  documentType: TSupportedOcrDocumentType,
  formData: Record<string, any>,
): TOcrData {
  const lowerCaseFirstLetterDocumentType = stringUtils.lowerCaseFirstLetter(documentType);
  return {
    type: documentType,
    [lowerCaseFirstLetterDocumentType]: formData,
  };
}

export function checkIsEmptyForm(formData: Record<string, any>) {
  const copyiedFormData = { ...formData };
  delete copyiedFormData.type;
  const isEmptyForm = Object.values(copyiedFormData).every(
    (value) => !value || Object.keys(value || {}).length < 1,
  );
  return isEmptyForm;
}
